var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GeneralScaffold',[_c('PagedDataTable',{attrs:{"i18nGroup":"weeklySign","form-route":"weeklySignForm","headers":_vm.headers,"repository":_vm.weeklySignRepository}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }